
<template>
  <div>
    <hr class="print-only" style="position: absolute; top: 1px; width: 90%; margin-left: 126px;">
    <hr class="print-only" style="position: absolute; top: 40px; width: 90%; margin-left: 111px;">
    <div class="print-only header-margin">
      <div class="print-header-logo">
        <img src="~CommonBilling/assets/24_hour_fitness.svg" width="100" height="70" style="border: 1px solid #ccc; position: relative; left: 19px"/>
        <span>{{breadcrumb}}</span>
      </div>
    </div>
    <div class="title-container" >
      <h3 class="title-24 title-line">{{titleHeader}}</h3>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'printHeader',
    props: [
      'breadcrumb',
      'titleHeader'
    ]
  }
</script>
<style lang="scss">
  @import '~CommonBilling/css/variables';

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #333;
    margin: 1em 0;
    padding: 0;
  }

  .title-container {
    margin-bottom: 30px;
  }

  .header-margin {
    margin-bottom: 40px;
  }

  .print-header-logo {
    span {
      font-weight: bold;
      margin-left: 30px;
    }
  }

  .title-line {
    border-bottom: 1px solid red;
  }

  .print-header-logo {
    img {
      border: 1px solid #333;
      -webkit-transform: skew(-20deg);
      -moz-transform: skew(-20deg);
      -ms-transform: skew(-20deg);
      -o-transform: skew(-20deg);
      transform: skew(-20deg);
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/PaymentConfirmation/PrintHeader.vue